import React from "react";
import { facepaintMediaQueries } from "../shared";
import { colors, borderRadius, grid, Heading, Body } from "../../";
import { unwrapFragment } from "../shared/utils";
import { jsx as ___EmotionJSX } from "@emotion/core";

function card(hasTitle, hasDescription, hasActions, hasContent) {
  var cardElements = [hasTitle ? "header" : null, hasActions ? "actions" : null, hasDescription ? "description" : null, hasContent ? "content" : null];
  var mobileGrid = cardElements.filter(Boolean).map(function (row) {
    return "\"".concat(row, "\"");
  });
  var largerScreenGrid = [[cardElements[0], cardElements[1]], hasTitle && hasActions ? [cardElements[2], cardElements[2]] : [cardElements[2]], hasTitle && hasActions ? [cardElements[3], cardElements[3]] : [cardElements[3]]].flatMap(function (x) {
    return x.join(" ").trim();
  }).filter(function (x) {
    return x.length > 0;
  }).map(function (x) {
    return "\"".concat(x, "\"");
  });
  return facepaintMediaQueries({
    display: "grid",
    gridTemplateAreas: [// Mobile
    mobileGrid.join("\n"), // Up
    largerScreenGrid.join("\n")],
    gridTemplateRows: ["repeat(".concat(mobileGrid.length, ", min-content)"), "repeat(".concat(largerScreenGrid.length, ", min-content)")],
    gridGap: [4, grid.xsmall],
    padding: [grid.small, grid.medium],
    paddingTop: [grid.xsmall, grid.small],
    paddingBottom: [grid.xsmall, grid.small],
    border: "solid 1px ".concat(colors.gray.cardBorder),
    borderLeftWidth: [0, 1],
    borderRightWidth: [0, 1],
    borderRadius: [0, borderRadius.medium],
    background: colors.white
  });
}

var headerArea = {
  color: colors.gray.inkHeadings,
  gridArea: "header"
};
var descriptionArea = {
  color: colors.gray.inkBody,
  gridArea: "description"
};
var actionArea = facepaintMediaQueries({
  gridArea: "actions",
  justifySelf: ["auto", "end"],
  display: "flex",
  flexWrap: "wrap",
  justifyContent: ["auto", "flex-end"],
  marginTop: [0, -grid.xsmall],
  marginRight: -grid.xsmall
});
var actionItem = facepaintMediaQueries({
  paddingTop: grid.xsmall,
  paddingRight: grid.xsmall
});
var content = facepaintMediaQueries({
  gridArea: "content"
});
export var Card = function Card(_ref) {
  var title = _ref.title,
      description = _ref.description,
      _ref$renderTitleAs = _ref.renderTitleAs,
      renderTitleAs = _ref$renderTitleAs === void 0 ? "h2" : _ref$renderTitleAs,
      children = _ref.children,
      className = _ref.className,
      actions = _ref.actions;
  return ___EmotionJSX("div", {
    css: card(!!title, !!description, !!actions, !!children),
    className: className
  }, title ? ___EmotionJSX("div", {
    css: headerArea
  }, ___EmotionJSX(Heading, {
    level: "1",
    renderAs: renderTitleAs
  }, title)) : null, description ? ___EmotionJSX("div", {
    css: descriptionArea
  }, ___EmotionJSX(Body, null, description)) : null, actions ? ___EmotionJSX("div", {
    css: actionArea
  }, React.Children.map(unwrapFragment(actions), function (action) {
    return ___EmotionJSX("div", {
      css: actionItem
    }, React.cloneElement(action, {
      size: "small"
    }));
  })) : null, children ? ___EmotionJSX("div", {
    css: content
  }, children) : null);
};